









import { Component, Mixins } from "vue-property-decorator";
import { FatalIndicator, QuotedBadge } from "./common";
import { TextInputtableContentMixin } from "./mixins";

@Component({
  components: {
    FatalIndicator,
    QuotedBadge,
  }
})
export default class WizardContentTextEditor extends Mixins(TextInputtableContentMixin) {
}
